"use strict";
// @ts-ignore
try {
    self['workbox:expiration:6.5.2'] && _();
}
catch (e) { }
